// extracted by mini-css-extract-plugin
export var galerieContainer = "galerie-images-module--galerie-container--2ede1";
export var galerieImage = "galerie-images-module--galerie-image--de71f";
export var galerieItemContainer = "galerie-images-module--galerie-item-container--b9633";
export var galerieItemDescription = "galerie-images-module--galerie-item-description--4559a";
export var galerieItemHeader = "galerie-images-module--galerie-item-header--ad058";
export var galerieItemLink = "galerie-images-module--galerie-item-link--9c92f";
export var galerieItemTitle = "galerie-images-module--galerie-item-title--dc0ce";
export var masonryGrid = "galerie-images-module--masonry-grid--f1cce";
export var masonryGridColumn = "galerie-images-module--masonry-grid-column--d7770";